export default __webpack_public_path__ + "img/f653d7cf73bc1d7eefbbcd85390c556b.svg";